'use strict';
module.exports = function(param) {
    if (Odigeo._.isArray(param)) {
        return Odigeo._.sample(param);
    } else if (Odigeo._.isObject(param) && Odigeo._.isNumber(param.min) && Odigeo._.isNumber(param.max)) {
        return Odigeo._.random(param.min, param.max);
    } else {
        return param;
    }
};

